export enum RuleSetType {
  Receipt = 1,
  UserGenerated,
}
